import { defaultConfig, validateConfig } from './config-schema'
export { defaultConfig, validateConfig }
const clone = value => JSON.parse(JSON.stringify(value))
export const menuConfig = defaultConfig()
// Resolve from the emitted asset base so both / and /config-web/ use one file.
const base = document.querySelector('meta[name="factory-base"]')
const fileUrl = new URL((base ? base.content : './') + 'menu-config.json', document.baseURI).href
const apiUrl = new URL('api/menu-config', fileUrl).href
export async function reloadConfig() {
  const response = await fetch(fileUrl, { cache: 'no-store' })
  if (!response.ok) throw new Error('无法读取菜单配置文件')
  const checked = validateConfig(await response.json())
  menuConfig.workshops = checked.workshops
  return clone(menuConfig)
}
export async function saveConfig(input) {
  const checked = validateConfig(input)
  const response = await fetch(apiUrl, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(checked) })
  if (!response.ok) {
    let message = '保存失败：请使用 npm run serve 启动本地配置服务'
    try { message = (await response.json()).error || message } catch (e) { /* Static hosting does not provide the write endpoint. */ }
    throw new Error(message)
  }
  const saved = validateConfig(await response.json())
  menuConfig.workshops = saved.workshops
  return clone(menuConfig)
}
export function methodCopy(id) {
  for (const c of menuConfig.workshops.flatMap(w=>w.children)) {
    const found = c.methods.find(m => m.id === id)
    if (found) return found
  }
  return { name: '工位', group: '车间', hint: '处理经过的货物' }
}
